<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

      <div v-if="userInfo.type_id != 4" class="flex flex-wrap-reverse items-center" style="position: relative;z-index: 1;">
          <flat-pickr class="mx-3 mb-4" :config="configFromdateTimePicker" v-model="fromDate" :placeholder="$t('fromDate')" style="width: 110px;"/>
          <div style="position: relative;top: -4px;">/</div>
          <flat-pickr class="mx-3 mb-4" :config="configTodateTimePicker" v-model="toDate" :placeholder="$t('toDate')" style="width: 110px;"/>

          <vs-input class="inputx mx-3 mb-4" :placeholder="$t('searchById')" v-model="id"/>
          <vs-input class="inputx mx-3 mb-4" :placeholder="$t('searchBySku')" v-model="sku"/>
          <vs-input class="inputx mx-3 mb-4" :placeholder="$t('searchByProductName')" v-model="name"/>

            <!-- они пока в бэке не правильно работают-->
          <!--
          <vs-select multiple v-model="group_id" class="inputx mx-3 mb-4" :placeholder="$t('userGroup')" v-if="userInfo.type_id == 3">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in orderFilters.groups" class="w-full" />
          </vs-select>
          <vs-select multiple v-model="users_id" class="inputx mx-3 mb-4" :placeholder="$t('users')">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in orderFilters.child" class="w-full" />
          </vs-select>
          -->
      </div>


    <vs-table ref="table"
              :sst="true"
              :data="orders.items"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div></div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" style="position: relative;z-index: 2;">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ orders.from }} - {{ orders.to }} of {{ orders.total }} | Show {{ itemsPerPage }} entries</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=5"><span>5</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25"><span>25</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>{{ $t('id') }}</vs-th>
        <vs-th>{{ $t('sku') }} ({{ $t('quantity_short') }})</vs-th>
        <vs-th>{{ $t('UnitPrice') }}</vs-th>
        <vs-th>{{ $t('price') }}</vs-th>
        <vs-th>{{ $t('ProductName') }}</vs-th>
        <vs-th width="120">{{ $t('date') }}</vs-th>
        <vs-th width="1"  v-if="userInfo.type_id == 3 || userInfo.type_id == 4">{{ $t('keys') }}</vs-th>
        <vs-th width="1">{{ $t('status') }}</vs-th>
        <vs-th>{{ $t('TotalPrice') }}</vs-th>
      </template>

      <template slot-scope="{data}">
          <tbody ref="table_modal" :data="item" :key="index" v-for="(item,index) in data">
              <tr @click="activeModal(item.id)" :style="item.order_returned_id > 0 ? 'text-decoration: line-through;' : ''">
                  <vs-td>{{ item.id }}</vs-td>
                  <vs-td style="white-space: nowrap;" v-html="productSku(item.products)"></vs-td>
                  <vs-td style="white-space: nowrap;" v-html="productUnitPrice(item.products)"></vs-td>
                  <vs-td v-html="productPrice(item.products)"></vs-td>
                  <vs-td v-html="productName(item.products)"></vs-td>
                  <vs-td style="white-space: nowrap;">{{ item.created_at }}</vs-td>
                  <vs-td  v-if="userInfo.type_id == 3 || userInfo.type_id == 4">
                      <template v-if="item.products[0] !== undefined && item.products[0].provider_id === 3 && item.order_returned_id === 0 && item.status.key === 1">
                          <vs-button class="mt-3" size="small" color="danger" type="filled" @click.stop="returnAdobeOrder(item.products[0].order_id)">
                              {{ $t('return') }}
                          </vs-button>
                      </template>
                      <template v-else>
                          <order-popup v-if="item.status.key === 1 && item.keys" :data="item" :key="item.id"></order-popup>
                      </template>
                  </vs-td>
                  <vs-td>
                      <vx-tooltip v-if="item.status.key === 3" :text="$t('in_progress')" position="bottom">
                          <vs-button radius color="warning" type="filled" disabled style="padding: 13px;opacity: 1;"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-else-if="item.status.key === 2" :text="$t('pending')" position="bottom">
                          <vs-button radius color="warning" type="filled" disabled style="padding: 13px;opacity: 1;"></vs-button>
                      </vx-tooltip>
                      <vs-button v-else-if="item.status.key === 1" radius color="success" type="filled" disabled style="padding: 13px;opacity: 1;"></vs-button>
                      <template v-else>
                          <vx-tooltip v-if="item.status.response !== ''" :text="item.status.response" position="bottom">
                              <vs-button radius color="danger" type="filled" disabled style="padding: 13px;opacity: 1;"></vs-button>
                          </vx-tooltip>
                          <vs-button v-else radius color="danger" type="filled" disabled style="padding: 13px;opacity: 1;"></vs-button>
                      </template>
                  </vs-td>
                  <vs-td style="white-space: nowrap;">{{ item.total_price }}<span v-if="!userInfo.need_azn_cash">$</span><span v-else> AZN</span></vs-td>
              </tr>
              <vs-tr style="display: none" :id="'comment_'+item.id" :key="item.id" class="comments">
                  <vs-td class="circle__comments" colspan="9">
                      <div class="mb-3">{{ $t('comments') }}</div>
<!--                      <order-comments v-if="userInfo.markup_group_id == 5" :item="item"></order-comments>
                      <vs-textarea v-else disabled v-model="item.comment"/>-->
                      <vs-textarea disabled v-model="item.comment"/>
                      <div style="margin-left: auto;">
                          <order-select v-if="userInfo.id == 6" :item="item" :users="users"></order-select>
                          <span v-else>{{ $t('soldBy') }} : {{ item.buyers }}</span>
                      </div>
                  </vs-td>
              </vs-tr>
          </tbody>
      </template>
    </vs-table>
  <div class="con-pagination-table vs-table--pagination" v-if="orders.total > itemsPerPage">
      <vs-pagination :key="paginateIndexKey" :total="orders.last_page" :max-items="itemsPerPage" :size-array="orders.total" v-model="page"></vs-pagination>
  </div>

   <!-- <vs-button style="display: block; margin-left: auto" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export
      as CSV
    </vs-button>-->
  </div>
</template>

<script>
  import OrderPopup from "../components/OrderPopup";
  import OrderComments from "../components/OrderComments";
  import OrderSelect from "../components/OrderSelect";
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import groups from "@/views/pages/Groups.vue";
  import time from "echarts/src/scale/Time";

  export default {
    components: {
      OrderPopup,
      OrderComments,
      OrderSelect,
      flatPickr,
    },
    data() {
      return {
        userInfo: window.userInfo,
        orderFilters: [],
        orders: [],
        fromDate: null,
        toDate: null,
        page: 1,
        id: '',
        sku: '',
        name: '',
        group_id: [],
        users_id: [],
        users: [],
          paginateIndexKey: 1,

        value2: '',
        value4: '',
        show: false,
        textarea: '',
        isActive: false,
        itemsPerPage: window.itemsPerPage,
        isMounted: false,
        addNewDataSidebar: false,
        configFromdateTimePicker: {
            minDate: null,
            maxDate: new Date()
        },
        configTodateTimePicker: {
            minDate: null,
            maxDate: new Date()
        }
      }
    },
    computed: {
        groups() {
            return groups
        },
        filteredList() {
            if (this.isMounted) {
                this.$refs.table.currentx = 1;
            }
            let filtered =  this.orders.items;

            if (this.fromDate !== null) {
                filtered = filtered.filter(order => {
                    if (this.fromDate <= order.created_at) return true;
                });
            }
            if (this.toDate !== null) {
                filtered = filtered.filter(order => {
                    if (this.toDate >= order.created_at) return true;
                });
            }
            if (this.id !== '') {
                filtered = filtered.filter(order => {
                    if (order.id.toLowerCase().search(this.id.toLowerCase()) !== -1) return true;
                });
            }
            if (this.sku !== '') {
                filtered = filtered.filter(order => {
                    let _return = false;
                    let thisInst = this;
                    order.products.forEach(function(product) {
                        if (product.sku.toLowerCase().search(thisInst.sku.toLowerCase()) !== -1) _return = true;
                    });
                    return _return;
                });
            }
            if (this.name !== '') {
                filtered = filtered.filter(order => {
                    let _return = false;
                    let thisInst = this;
                    order.products.forEach(function(product) {
                        if (product.name.toLowerCase().search(thisInst.name.toLowerCase()) !== -1) _return = true;
                    });
                    return _return;
                });
            }
            if (this.group_id.length > 0){
                filtered = filtered.filter(order => {
                    let _return = false;
                    let thisInst = this;
                    this.group_id.forEach(function(groupId) {
                        thisInst.orderFilters.groupUsers[groupId].forEach(function(userId) {
                            if (order.boughtTree.indexOf(userId) !== -1) _return = true;
                        });
                    });
                    return _return;
                });
            }
            if (this.users_id.length > 0){
                filtered = filtered.filter(order => {
                    let _return = false;
                    this.users_id.forEach(function(userId) {
                        if (order.boughtTree.indexOf(userId) !== -1) _return = true;
                    });
                    return _return;
                });
            }

            return filtered;
        },
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
    },
    methods: {
        openConfirm(orderId) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('confirm'),
                text: 'Are you sure?',
                accept: ()=>{ this.returnAdobeOrder(orderId, false) }
            })
        },
        returnAdobeOrder(orderId, needConfirm = true) {
            if (needConfirm) {
                this.openConfirm(orderId);
                return false;
            }

            this.$vs.loading();
            let thisIns = this;
            axios.get(apiUrl + '/order/' + orderId + '/return?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.getOrders();
                    }
                    else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }

                    thisIns.$vs.loading.close();
                });
        },
        getOrders(){
            this.$vs.loading();
            const thisIns = this;
            const params = {
                length: this.itemsPerPage,
                page: this.page,
                token: token,
                fromDate: this.fromDate,
                toDate: this.toDate,
                id: this.id,
                sku: this.sku,
                name: this.name,
                group_id: this.group_id,
                users_id: this.users_id,
            };
            const u = new URLSearchParams(params).toString();

            axios.get(apiUrl+'/orders?'+u)
                .then(function (response) {
                    let data = response.data;
                    if(data.code === 200){
                        thisIns.orders = data.data;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.paginateIndexKey++;
                    thisIns.$vs.loading.close();
                });
        },
        handleChangePage(page) {
            this.page = page;
            this.getOrders();
        },
        currencyReturn(){
          return this.userInfo.need_azn_cash ? ' AZN' : '$';
        },
        productSku(prodInfo){
            let _return  = '';
            prodInfo.forEach(function (item) {
                _return += item.sku+' ('+item.count+')<br>';
            });
            return _return;
        },
        productUnitPrice(prodInfo){
            let _return  = '';
            prodInfo.forEach((item) => {
                let days = '';
                if(item.provider_id == 3 && item.days != '') {
                    days = ' (' + item.days + ')';
                }
                _return += item.price+this.currencyReturn()+' '+days+'<br>';
            });
            return _return;
        },
        productPrice(prodInfo){
            let _return  = '';
            prodInfo.forEach((item) => {
                let pr = 0;
                if (item.attempt < 5) pr = item.price * item.count;
                _return += this.number_format(pr)+this.currencyReturn()+'<br>';
            });
            return _return;
        },
        number_format(x) {
          return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        productName(prodInfo){
            let _return  = '';
            prodInfo.forEach(function (item) {
                _return += item.name+'<br>';
            });
            return _return;
        },
        activeModal(id){
            let actived = document.getElementById('comment_'+id).style.display;

            let comments = document.getElementsByClassName('comments');
            for (let i = 0; i < comments.length; i++) {
                comments[i].style.display = 'none';
            }

            if (actived == 'table-row'){
                document.getElementById('comment_'+id).style.display = 'none';
            }
            else if(actived == 'none'){
                document.getElementById('comment_'+id).style.display = 'table-row';
            }
        },
    },
    created() {
      const thisIns = this;
        window.updateMyProfile();

        this.getOrders();

        axios.get(apiUrl+'/order/filters?token='+token)
            .then(function (response) {

                let data = response.data;
                if(data.code === 200){
                    thisIns.orderFilters = data.data;
                }else{
                    if (data.code === 401){
                        window.logout();
                    }
                    thisIns.$vs.notify({
                        title: 'Error',
                        text:  data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                }

            });

        if (this.userInfo.id == 6) {
            axios.get(apiUrl + '/users?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {

                        let users = [];
                        users.push({
                            'id' : userInfo.id,
                            'label' : userInfo.name,
                        });
                        data.data.forEach(function (user) {
                            users.push({
                                'id' : user.id,
                                'label' : user.name,
                            });
                        });

                        thisIns.users = users;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });
        }
    },
    mounted() {
      this.isMounted = true;
    },
      watch: {
          id: function () {
              this.getOrders();
          },
          sku: function () {
              this.getOrders();
          },
          name: function () {
              this.getOrders();
          },
          group_id: function () {
              this.getOrders();
          },
          users_id: function () {
              this.getOrders();
          },
          page: function () {
              this.getOrders();
          },
          fromDate(){
              this.getOrders();
          },
          toDate(value){
              this.configFromdateTimePicker.maxDate = value;
              this.getOrders();
          },
          itemsPerPage(stage){
              localStorage.setItem('itemsPerPage', stage);
              window.itemsPerPage = stage;
              this.getOrders();
          }
      }
  }
</script>

<style lang="scss">

    .textarea {
        color: rgba(var(--vs-primary), 1) !important;
    }

    .vs-popup--content{
        td{
            .returned{
                text-decoration: line-through;
            }
            .returned_pending{
                color: orangered;
                text-decoration: line-through;
            }
        }
    }

  .active {
    path {
      fill: #d92121 !important;
    }
  }

  .vs-table--td:nth-of-type(7), .vs-table--td:nth-of-type(8){
    span {
      width: 40%;
      display: flex;
      justify-content: center;
    }
  }

  .ui-selected {
    background: rgba(var(--vs-primary), .05) !important;
    color: rgba(var(--vs-primary), 1);
    -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  }

  .td-check {
    display: none !important;
  }

  #data-list-list-view {
    .vs-con-table {

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
